module.exports = __webpack_public_path__ + "assets/img/forum3.90af9a1e.png";